angular.module('mso.services').constant('featureToggleService', {
});